




















































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class CustomApp extends Vue {
  
}
